import { render, staticRenderFns } from "./StorageForm.vue?vue&type=template&id=e20e3bf0"
import script from "./StorageForm.vue?vue&type=script&lang=js"
export * from "./StorageForm.vue?vue&type=script&lang=js"
import style0 from "./StorageForm.vue?vue&type=style&index=0&id=e20e3bf0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports